'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useMemo, useRef, useState } from 'react';

import Text from 'components/ui/Text';

import useMediaQuery from 'hooks/useMediaQuery';

import styles from './OurJourneyNav.module.scss';

const OurJourneyNav = ({
    overlayChapters,
    activeNavId,
    onNavClick,
    x,
    carouselDistance,
}) => {
    const rootRef = useRef(null);
    const labelRefs = useRef([]);
    const indicatorRef = useRef(null);
    const listRef = useRef(null);
    const listItemRef = useRef(null);
    const [labelMetrics, setLabelMetrics] = useState([]);
    const [listWidth, setListWidth] = useState(0);
    const [listLeftOffset, setListLeftOffset] = useState(0);
    const [labelOffset, setLabelOffset] = useState(0);

    const isMedium = useMediaQuery('(min-width: 768px)');
    const isLarge = useMediaQuery('(min-width: 1024px)');

    const activeMetric = labelMetrics.find(
        metric => overlayChapters[metric.index].id === activeNavId
    );

    useEffect(() => {
        const unsubscribe = x.on('change', latestX => {
            const transformedX =
                (latestX / carouselDistance) *
                (listWidth - labelOffset + activeMetric?.widthAdjust);
            indicatorRef.current.style.transform = `translateX(${-transformedX}px)`;
        });

        return () => unsubscribe();
    }, [x, carouselDistance, listWidth, labelOffset, activeMetric]);

    const customOffsetAdjust = useMemo(
        () => ({
            0: 0,
            1: 0,
            2: isLarge ? 1 : isMedium ? -1 : -2,
            3: isLarge ? 7 : isMedium ? 2 : 2,
        }),
        [isLarge, isMedium]
    );

    useEffect(() => {
        const updateMetrics = () => {
            const padding = isLarge ? 24 : 16;

            if (rootRef.current) {
                const metrics = labelRefs.current.map((label, index) => {
                    const rect = label.getBoundingClientRect();
                    const width = rect.width + padding;
                    const widthAdjust = customOffsetAdjust[index] || 0;

                    return { index, width, widthAdjust };
                });
                const widths = metrics.map(metric => metric.width);
                const smallestWidth = Math.min(...widths);

                setLabelMetrics(metrics);
                setLabelOffset(smallestWidth - 1);
            }

            if (listRef.current) {
                const rect = listRef.current.getBoundingClientRect();
                const itemRect = listItemRef.current.getBoundingClientRect();
                setListWidth(rect.width);
                setListLeftOffset(itemRect.left);
            }
        };

        updateMetrics();

        window.addEventListener('resize', updateMetrics);

        return () => {
            window.removeEventListener('resize', updateMetrics);
        };
    }, [overlayChapters, isLarge, customOffsetAdjust]);

    return (
        <nav className={styles.root}>
            <div ref={rootRef} className={styles.inner}>
                <div
                    className={styles.indicatorContainer}
                    style={{
                        left: `${listLeftOffset}px`,
                    }}
                >
                    <div
                        ref={indicatorRef}
                        className={styles.indicator}
                        aria-hidden="true"
                        style={{
                            width: activeMetric?.width,
                            backgroundColor: `var(--tales-color-${
                                overlayChapters[activeMetric?.index]?.color
                            })`,
                        }}
                    />
                </div>
                <ul ref={listRef} className={styles.list}>
                    {overlayChapters.map((chapter, index) => (
                        <li
                            ref={index === 0 ? listItemRef : null}
                            key={index}
                            className={styles.item}
                        >
                            <button
                                className={styles.button}
                                onClick={() => {
                                    onNavClick(chapter.id);
                                }}
                            >
                                <Text
                                    className={styles.label}
                                    baseTheme="labelSmall"
                                >
                                    <span
                                        ref={el =>
                                            (labelRefs.current[index] = el)
                                        }
                                        className={styles.labelInner}
                                    >
                                        {chapter.years}
                                    </span>
                                </Text>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </nav>
    );
};

export default OurJourneyNav;
